const ITEM_HEIGHT = 216;

const ITEM_WIDTH = 170;

export const PAPER_PROPS_ITEM_STYLE = {
  maxHeight: ITEM_HEIGHT,
  width: ITEM_WIDTH,
};
